export default "__VITE_ASSET__Ba0oSRxv__"